var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.country && _vm.country !== ""
    ? _c("span", { staticClass: "pr-1" }, [
        _c("img", {
          attrs: {
            height: "11",
            src: _vm.flagUrl,
            title: _vm.displayTitle,
            width: "16"
          }
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }